import client from './client';

export interface RenderPresetSettings {
  environment?: Record<string, unknown>;
  effects?: Record<string, unknown>;
  lights?: Array<Record<string, unknown>>;
}

export interface RenderPresetItem {
  id: string | null;
  key: string;
  name: string;
  description: string;
  tags: string[];
  settings: RenderPresetSettings;
  builtin: boolean;
  reason?: string;
  score?: number;
}

export async function fetchRenderPresets(): Promise<{ items: RenderPresetItem[] }> {
  const { data } = await client.get('/render-presets');
  return data;
}

export async function recommendRenderPresets(body: { prompt?: string; sceneName?: string }): Promise<{
  source: 'llm' | 'heuristic';
  items: RenderPresetItem[];
}> {
  const { data } = await client.post('/render-presets/recommend', body);
  return data;
}

export async function createRenderPreset(body: {
  name: string;
  description?: string;
  tags?: string[];
  settings: RenderPresetSettings;
}): Promise<RenderPresetItem> {
  const { data } = await client.post('/render-presets', body);
  return data;
}

export async function deleteRenderPreset(id: string): Promise<void> {
  await client.delete(`/render-presets/${id}`);
}

// ── I2：材质包（material_lib 打底） ──

export interface MaterialPresetItem {
  key: string;
  name: string;
  category: 'building' | 'industrial' | 'interior' | 'ground';
  description: string;
  tags: string[];
  material: {
    name: string;
    color: string;
    opacity: number;
    metalness: number;
    roughness: number;
    emissive?: string;
    emissiveIntensity?: number;
  };
}

export async function fetchMaterialPresets(q?: string): Promise<{ items: MaterialPresetItem[] }> {
  const { data } = await client.get('/render-presets/materials', { params: q ? { q } : {} });
  return data;
}
